import { render, staticRenderFns } from "./etcModal.vue?vue&type=template&id=af049a2a&scoped=true"
import script from "./etcModal.vue?vue&type=script&lang=js"
export * from "./etcModal.vue?vue&type=script&lang=js"
import style0 from "./etcModal.vue?vue&type=style&index=0&id=af049a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af049a2a",
  null
  
)

export default component.exports